import {useRef, useState} from 'react';
import {Banner} from '@shopify/polaris';
import {useI18n} from '@shopify/react-i18n';
import classnames from 'classnames';
import useWindowDimensions from 'utilities/use-window-dimensions';
import {ShopLocale} from 'utilities/use-shop-locales-and-markets';

import styles from './MachineTranslationsReadyBanner.scss';

const I18N_SCOPE = 'MachineTranslationsReadyBanner';

interface Props {
  locale: ShopLocale;
  preview: () => void;
}

export function MachineTranslationsReadyBanner({locale, preview}: Props) {
  const [dismissed, setDismissed] = useState(false);
  const [i18n] = useI18n();
  const {width} = useWindowDimensions();
  const bannerRef = useRef(null);

  return dismissed ? null : (
    <div
      className={classnames(
        styles.MachineTranslationsReadyContainer,
        styles.NoIllustration,
        width < 788 ? styles.Collapsed : null,
      )}
    >
      <div ref={bannerRef}>
        <Banner
          tone="success"
          title={i18n.translate(
            'storeReadyForLanguage',
            {scope: [I18N_SCOPE]},
            {language: locale.name || ''},
          )}
          action={{
            content: i18n.translate(
              'viewStoreInLanguage',
              {scope: [I18N_SCOPE]},
              {language: locale.name || ''},
            ),
            onAction: preview,
          }}
          onDismiss={() => setDismissed(true)}
        >
          {i18n.translate('reviewAndEdit', {scope: [I18N_SCOPE]})}
        </Banner>
      </div>
    </div>
  );
}
